module.exports = __webpack_public_path__ + "img/demo.91585083.svg";